<script lang="ts">
  import GhostButton from "../../../../../_shared/_modules/ghost-button"
  import {
    fetchPlanningSettings,
    type PlanningSettingsResponse,
  } from "../../../../../../api/kehrblatt/planning"
  import type { OrgaViewFrameContext } from "../../../../context"
  import PlanningSettingsForm from "./_modules/planning-settings-form"

  const { viewFrameContext } = $props<{ viewFrameContext: OrgaViewFrameContext }>()
  const organizationId = $derived(
    viewFrameContext.organization?.id ?? viewFrameContext.organizationId ?? "",
  )
  const canManage = $derived(viewFrameContext.permissions.allows("core.org_settings", "manage"))
  const canView = $derived(
    canManage || viewFrameContext.permissions.allows("core.org_settings", "view"),
  )
  let settings = $state<PlanningSettingsResponse | null>(null)
  let loading = $state(false)
  let error = $state<string | null>(null)
  let generation = 0

  const load = async (targetOrganization: string) => {
    const request = ++generation
    settings = null
    loading = true
    error = null
    try {
      const result = await fetchPlanningSettings(targetOrganization)

      if (request !== generation || targetOrganization !== organizationId) return

      settings = result
    } catch {
      if (request === generation) error = "Termineinstellungen konnten nicht geladen werden."
    } finally {
      if (request === generation) loading = false
    }
  }

  $effect(() => {
    const targetOrganization = organizationId
    const allowed = canView
    settings = null
    error = null
    loading = false

    if (targetOrganization && allowed) void load(targetOrganization)

    return () => {
      generation += 1
    }
  })
</script>

{#if !canView}
  <p>Sie haben keinen Zugriff auf die Termineinstellungen.</p>
{:else if error}
  <div class="state-block">
    <p role="alert">{error}</p>
    <GhostButton onclick={() => load(organizationId)}>Erneut laden</GhostButton>
  </div>
{:else if loading || !settings}
  <p role="status">Termineinstellungen werden geladen.</p>
{:else}
  {#key organizationId}
    <PlanningSettingsForm
      {organizationId}
      {settings}
      {canManage}
      onSettingsUpdated={(updated) => {
        settings = updated
      }}
    />
  {/key}
{/if}

<style>
  .state-block {
    display: flex;
    align-items: center;
    gap: 0.75rem;
    flex-wrap: wrap;
  }
</style>
